// Audience Manager CSV upload: is this row's phone usable, and in what form (CU-869fnwgxf)?
// Uses the shared lead-phone rule (./phoneCheck), passed in as `lib` because the component
// loads it on demand. Same answers as the desk-phone dial and the backend. Safe clean-ups
// only (spaces, punctuation, 00 → +); never adds or removes a digit, never guesses a
// country. Returns the shape UploadFileV2 already uses: { valid, originalNumber, fixedNumber }.
export function fixAudiencePhone(input, lib) {
    const originalNumber = input || '';
    let cleaned = String(originalNumber).trim();
    const compact = cleaned.replace(/[\s().-]/g, '');
    if (compact.startsWith('00')) cleaned = `+${compact.slice(2)}`;
    const check = lib ? lib.checkLeadPhone(cleaned) : null;
    if (!check || !check.ok) {
        return { valid: false, originalNumber, fixedNumber: null, reason: check?.message || '' };
    }
    return { valid: true, originalNumber, fixedNumber: lib.toE164(cleaned) };
}
